const FilledTrashcanWithBgIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 33.25C26.8701 33.25 33.25 26.8701 33.25 19C33.25 11.1299 26.8701 4.75 19 4.75C11.1299 4.75 4.75 11.1299 4.75 19C4.75 26.8701 11.1299 33.25 19 33.25Z"
        fill="white"
        fillOpacity="0.12"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1229 14.0075C25.4103 14.0075 25.6496 14.2462 25.6496 14.5499V14.8306C25.6496 15.1269 25.4103 15.373 25.1229 15.373H12.8771C12.5889 15.373 12.3496 15.1269 12.3496 14.8306V14.5499C12.3496 14.2462 12.5889 14.0075 12.8771 14.0075H15.0315C15.4691 14.0075 15.85 13.6965 15.9484 13.2576L16.0612 12.7536C16.2366 12.0672 16.8136 11.6113 17.474 11.6113H20.5252C21.1784 11.6113 21.7619 12.0672 21.9308 12.7174L22.0515 13.2568C22.1493 13.6965 22.5301 14.0075 22.9685 14.0075H25.1229ZM24.0284 24.2715C24.2533 22.1753 24.6471 17.1952 24.6471 17.145C24.6615 16.9927 24.6119 16.8487 24.5134 16.7327C24.4078 16.624 24.2741 16.5598 24.1268 16.5598H13.878C13.73 16.5598 13.5891 16.624 13.4914 16.7327C13.3922 16.8487 13.3434 16.9927 13.3506 17.145C13.3519 17.1542 13.366 17.3296 13.3896 17.6229C13.4946 18.9257 13.7869 22.5544 13.9757 24.2715C14.1094 25.5364 14.9394 26.3315 16.1416 26.3603C17.0694 26.3817 18.0251 26.3891 19.0024 26.3891C19.9229 26.3891 20.8579 26.3817 21.8143 26.3603C23.0582 26.3389 23.8875 25.5579 24.0284 24.2715Z"
        fill="#599393"
      />
    </svg>
  );
};
export default FilledTrashcanWithBgIcon;
